<footer
  class="disclaimer-footer"
  [style.background-color]="ups.preferences()?.footerColor"
  role="contentinfo"
>
  <span class="disclaimer-footer__text">
    The estimate provided using this
    {{ shell.isAidQuiz() ? 'Financial Aid Quiz' : 'net price calculator' }}
    does not represent a final determination, or actual award, of financial
    assistance. The price of attendance and financial aid availability may change.
    @if (!shell.isAidQuiz()) {
      <span>
        This estimate shall not be binding on the Secretary of Education, this
        institution of higher education or the state in which this institution of
        higher education is located.
      </span>
    }
    Students must complete the Free Application for Federal Student Aid (FAFSA)
    in order to be eligible for, and receive, an actual financial aid award that
    includes federal grants, loans or work-study assistance. For more information
    on applying for federal student aid, please go to studentaid.gov.&emsp;
    <small>[Version {{ version }}]</small>
  </span>
</footer>
